import { useMutation } from '@tanstack/react-query'
import { verifyPaymentOriginator } from '@/app/lib/api-client'

export const useVerifyPaymentOriginator = () => {
  return useMutation({ mutationFn: verifyPaymentOriginator })
}
